import React, { useState } from "react";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { Box, Drawer, Button, List, ListItemButton, IconButton } from "@mui/material";
import Logo from "../assets/logo";

function MenuComponent() {

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    return (
        <div>
            <Drawer
                open={open}
                onClose={toggleDrawer(false)}
                aria-label="Menu principal"
            >
                <Box sx={{ width: 250 }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", padding: 1 }}>
                        <IconButton
                            onClick={toggleDrawer(false)}
                            aria-label="Fechar menu"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <List component="nav" style={{ padding: 16 }}>
                        <Logo />
                        <ListItemButton onClick={() => { navigate(`/`); setOpen(false); }} style={{ marginTop: 16 }}>
                            Página Inicial
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/diretoria`); setOpen(false); }}>
                            O Sindsep
                        </ListItemButton>
                        <ListItemButton
                            component="a"
                            href="https://sindicalizacao.sindsep-sp.org.br/"
                            rel="noreferrer"
                            target={"_blank"}
                            style={{
                                color: "#202020",
                                textDecoration: "none",
                                cursor: "pointer"
                            }}
                        >
                            Sindicalização<span className="sr-only"> </span>
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/servicos`); setOpen(false); }}>
                            Benefícios
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/precatorios`); setOpen(false); }}>
                            Precatórios
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/noticias`); setOpen(false); }}>
                            Notícias
                        </ListItemButton>
                        <ListItemButton
                            component="a"
                            href="https://www.youtube.com/c/SindsepSãoPaulo"
                            rel="noreferrer"
                            target={"_blank"}
                            style={{
                                color: "#202020",
                                textDecoration: "none",
                                cursor: "pointer"
                            }}
                        >
                            TV Sindsep<span className="sr-only"> </span>
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/galeria`); setOpen(false); }}>
                            Fotos
                        </ListItemButton>
                        <ListItemButton
                            component="a"
                            href="https://api.whatsapp.com/send?phone=5511970255497"
                            rel="noreferrer"
                            target={"_blank"}
                            style={{
                                color: "#202020",
                                textDecoration: "none",
                                cursor: "pointer"
                            }}
                        >
                            Fale conosco<span className="sr-only"> </span>
                        </ListItemButton>
                    </List>
                </Box>
            </Drawer>
            <Button
                id="demo-customized-button"
                aria-haspopup="true"
                aria-expanded={open ? "true" : "false"}
                aria-label="Abrir menu de navegação"
                variant="text"
                disableElevation
                onClick={toggleDrawer(true)}
                startIcon={<MenuIcon />}
                style={{
                    color: "#C81E1E",
                    fontFamily: "Raleway",
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "20px",
                }}
            >
                Menu
            </Button>
        </div>
    );
}

export default MenuComponent;
